import { ActionMenuPermissionsEnum } from '../core/enum/action-menu-permissions-enum';
import { Injectable } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { SessionsService } from './sessions.service';
import { SessionService } from '../core/services/session/session.service';
import { SistemaEnum } from '../core/enum/sistema-enum';

@Injectable({
  providedIn: 'root',
})
export class AuthTokenService {
  constructor(private sessionService: SessionsService, private session: SessionService) {}

  public atualizaPermissoes() {
    const token = this.sessionService.getSessions('login').tokenString;
    try {
      const claims = jwt_decode(token)['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
      this.atualiza(claims);
    } catch (Error) {
      return console.log('Erro ao atualizar permissões');
    }
  }

  private atualiza(claims: any[]) {
    this.sessionService.setSessions('permissoes', claims);
  }

  /**
   * Método verifica se a permissão existe na lista armazenada na sessão.
   * @param acao
   */
  possuiPermissao(acao: ActionMenuPermissionsEnum): boolean {
    const perfilSistema = this.session.getUserSession().usuarioPerfilSistemas.find((x) => x.codigoSistema === SistemaEnum.Bilhetagem.toString());

    let result = false;

    perfilSistema.usuarioPerfilMenus.forEach((menuResponse) => {
      menuResponse.usuarioPerfilAcoes.forEach((acaoResponse) => {
        if (acaoResponse.acaoID == <number>acao) {
          result = true;
        }
      });
    });

    return result;
  }
}
